exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".style__insertNode___3lYv7 {\n  cursor: crosshair; }\n  .style__insertNode___3lYv7 .storm-diagrams-canvas {\n    cursor: inherit; }\n\n.style__insertMode___1t5i3 {\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  opacity: 0.8;\n  z-index: 100; }\n  .style__insertMode___1t5i3 button {\n    margin-top: 10px; }\n", ""]);

// exports
exports.locals = {
	"insertNode": "style__insertNode___3lYv7",
	"insertMode": "style__insertMode___1t5i3"
};